import { TOKEN, USER_INFO } from "@/core/const/global-const";
import { LocalStorage } from "@/util";
import { Message } from "element-ui";
import StompClient from "./stomp-client";

export class SocketService {
  static getConnection() {
    return new Promise((resolve, reject) => {
      if (SocketService.client && SocketService.client.active) {
        resolve(SocketService.client);
      } else {
        const token = LocalStorage.get(TOKEN);
        if (!token) {
          reject(new Error("未检测到登录令牌，请先登录"));
          return;
        }
        const user = LocalStorage.get(USER_INFO);
        const url = `/notification?${TOKEN}=${token}`;
        // 传递用户ID作为headers，供后端识别用户身份
        const stompClient = new StompClient(url, { name: user?.id });
        SocketService.client = stompClient;
        stompClient.connect(
          () => {
            Message.success("推送消息连接成功");
            resolve(stompClient);
          },
          (error) => {
            console.error("Error connecting to STOMP:", error);
            Message.error("推送消息连接失败");
            reject(error);
          }
        );
      }
    });
  }

  static async subscribeTopic(topic, callback) {
    const stompClient = await SocketService.getConnection();
    // eslint-disable-next-line no-unused-vars
    const subscription = stompClient.subscribe(topic, (message) => {
      // console.log("Received message:", JSON.parse(message.body));
      callback(JSON.parse(message.body));
    });

    // Use `subscription` to unsubscribe if necessary
  }

  static disconnect() {
    if (SocketService.client) {
      SocketService.client.disconnect();
    }
  }
}
